import { Box, Button, Typography } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../../common/Context";
import { text } from "../../../../../theme/colours";

const HeaderBox = (props) => {
  const { bgColor, title, redirect, subTitle } = props;
  const { t } = useTranslation("Dashboard");
  const { setOptionState } = useContext(GlobalContext);

  const headerBoxStyle = {
    height: "2.5rem",
    width: "100%",
    borderRadius: "10px 10px 0 0",
    display: "flex",
    justifyContent: subTitle ? "flex-start" : "space-between",
    padding: "0.75rem",
    alignItems: "center",
    background: bgColor,
  };
  const headerStyle = {
    fontSize: "0.875rem",
    fontWeight: 700,
  };
  const seeMoreStyle = {
    fontSize: "0.875rem",
    fontWeight: 600,
    textTransform: "none",
    color: text.primary,
  };

  const changeNav = (type) => {
    setOptionState({ nav: type, page: "main" });
  };

  return (
    <Box sx={headerBoxStyle}>
      <Typography variant="h2" sx={headerStyle}>
        {title}
      </Typography>
      {subTitle && (
        <Typography variant="body1" sx={{ ml: "0.25rem" }}>
          {subTitle}
        </Typography>
      )}
      {redirect && (
        <Button onClick={() => changeNav(redirect)}>
          <Typography sx={seeMoreStyle}>{t("seeMore")}</Typography>
        </Button>
      )}
    </Box>
  );
};

export default HeaderBox;
